import"./backdrop-dialog.eee1318ab04a.js";

export class CareQuality {
  constructor() {
    document.addEventListener("click", (e) => {
      if (e.target.closest(".tqc-care-quality")) {
        document.getElementById("care-quality-modal")?.showModal();
      }
    });
  }
}
